import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, inject, signal, viewChild } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ButtonModule } from 'primeng/button';
import { Popover, PopoverModule } from 'primeng/popover';

interface LanguageOption {
  name: string;
  code: string;
  image: string;
}

@Component({
  selector: 'app-languages',
  imports: [ButtonModule, PopoverModule, NgClass, NgOptimizedImage],
  templateUrl: './languages.component.html',
  styleUrl: './languages.component.css',
})
export class LanguagesComponent {
  protected readonly translocoService = inject(TranslocoService);

  languagePopover = viewChild<Popover>('languagePopover');

  languageSelected = signal<LanguageOption | null>(null);
  languages: LanguageOption[] = [
    {
      name: 'Italiano',
      code: 'it',
      image: 'flag-it.svg',
    },
    {
      name: 'English',
      code: 'en',
      image: 'flag-en.svg',
    },
    {
      name: 'Français',
      code: 'fr',
      image: 'flag-fr.svg',
    },
    {
      name: 'Español',
      code: 'es',
      image: 'flag-es.svg',
    },
  ];

  onChangeLanguage(language: LanguageOption) {
    this.translocoService.setActiveLang(language.code);

    localStorage.setItem('language', language.code);

    this.languageSelected.set(language);
    this.languagePopover()?.hide();
  }

  toggleLanguagePopover(event: Event) {
    this.languagePopover()?.toggle(event);
  }
}
